module.exports = __webpack_public_path__ + "static/img/img-yamaha-mio.9c370bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/img-yamaha-mio.png
// module id = XVi4
// module chunks = 36